import {
    CLAN_UNITS_REQUEST,
    CLAN_UNITS_SUCCESS,
    CLAN_UNITS_SELECT_UNIT,
    UNIT_STATE_REACTIVE_UPDATE,
} from 'state/actions/clan_units'
import {
    CLAN_ACTIVE_UNITS_UPDATE,
} from 'channels/clan/actions'

const initialState = {
    units: [],
    loading: false,
    loaded: false,
    showLoader: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case CLAN_UNITS_REQUEST: {
        return {
            ...state,
            loaded: false,
            loading: true,
            showLoader: action.payload.showLoader,
        }
    }
    case UNIT_STATE_REACTIVE_UPDATE: {
        const unitToReplace = action.payload.unit
        const units = state.units.map(unit => (unit.id === unitToReplace.id) ? unitToReplace : unit)
        return {
            ...state,
            units,
        }
    }
    case CLAN_ACTIVE_UNITS_UPDATE: {
        return {
            ...state,
            loaded: false,
            loading: false,
        }
    }
    case CLAN_UNITS_SUCCESS: {
        return {
            ...state,
            loaded: true,
            loading: false,
            showLoader: false,
            units: action.payload.units,
            meta: action.payload.meta,
        }
    }
    case CLAN_UNITS_SELECT_UNIT: {
        return {
            ...state,
            selectedUnitId: action.payload.unitId,
        }
    }
    default: {
        return state
    }
    }
}



// WEBPACK FOOTER //
// ./state/reducers/units/clan_units.js